var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5137 2.1982C14.0437 -0.521797 17.9577 -0.521797 19.4857 2.1982L30.6457 22.0382C32.1457 24.7062 30.2197 27.9982 27.1617 27.9982H4.83969C1.7797 27.9982 -0.146303 24.7062 1.3537 22.0382L12.5137 2.1982ZM17.9997 22.0002C17.9997 22.5306 17.789 23.0393 17.4139 23.4144C17.0388 23.7895 16.5301 24.0002 15.9997 24.0002C15.4693 24.0002 14.9606 23.7895 14.5855 23.4144C14.2104 23.0393 13.9997 22.5306 13.9997 22.0002C13.9997 21.4698 14.2104 20.9611 14.5855 20.586C14.9606 20.2109 15.4693 20.0002 15.9997 20.0002C16.5301 20.0002 17.0388 20.2109 17.4139 20.586C17.789 20.9611 17.9997 21.4698 17.9997 22.0002ZM15.9997 6.0002C15.4693 6.0002 14.9606 6.21092 14.5855 6.58599C14.2104 6.96106 13.9997 7.46977 13.9997 8.0002V14.0002C13.9997 14.5306 14.2104 15.0393 14.5855 15.4144C14.9606 15.7895 15.4693 16.0002 15.9997 16.0002C16.5301 16.0002 17.0388 15.7895 17.4139 15.4144C17.789 15.0393 17.9997 14.5306 17.9997 14.0002V8.0002C17.9997 7.46977 17.789 6.96106 17.4139 6.58599C17.0388 6.21092 16.5301 6.0002 15.9997 6.0002Z",
    fill: "#F59E0B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.717a18ceb776572a0c5f3b0505bc2c98.svg";
export { ForwardRef as ReactComponent };